import { Box, Divider, Image, ModalContent } from '@modusign/design-system';
import { ReactNode } from 'react';

interface InvitationContentProps {
  title: ReactNode;
  image: string;
  content: ReactNode;
}

export default function InvitationContent({ content, image, title }: InvitationContentProps) {
  return (
    <Box mb={9} mt={7}>
      {title}
      <Divider mb={7} mt={4} />
      <Image src={image} width="100%" />
      <ModalContent mb={0} mt={7}>
        {content}
      </ModalContent>
    </Box>
  );
}
